module.exports = {"auth0_client_id":"y7sBfWuMpR0ko306K06FBjVzO88ibaZC","auth0_domain":"lyonnister.eu.auth0.com","auth0_audience":"https://e-coin.io","api":"https://e-coin.jonathan.pl","assets":{"blue":0,"red":0}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 30
// module chunks = 0